import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.tooling],
    info: construction.info.tooling,
    loaded: construction.parameters_loaded,
    selected: construction.selected.tooling
  })
);
